// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"CopyInput_ProseMirror__107w_","copyInput":"CopyInput_copyInput__SVZZ1","copyInput__control":"CopyInput_copyInput__control__2m5gg"};